/**
 * «Reintento solo cada 30 s» (hoy.html): en error, la consulta vuelve a
 * intentarlo sola. Vive aparte de queries.ts para que una vista que recibe
 * su cliente por props (el simulador) lo use sin cargar el cliente del
 * Studio ni su MSAL: así sus tests no tocan Entra.
 */
export const retryEvery30s = { refetchInterval: (q: { state: { status: string } }) => (q.state.status === "error" ? 30_000 : false) } as const;
